import { Component, OnInit, inject, ViewChild } from '@angular/core';
import { FormsModule, FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common';
import { ModalComponent } from "../../modal/modal.component";
import { InicioService } from '../../../services/inicio.service';
import { UsuarioService } from '../../../services/usuario.service';
import { appsettings } from '../../../settings/appsettings';

@Component({
  selector: 'app-carga-masiva-participante',
  standalone: true,
  imports: [ModalComponent, CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './carga-masiva-participante.component.html',
  styleUrl: './carga-masiva-participante.component.css'
})
export class CargaMasivaParticipanteComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;

  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  user: any;

  estado: any = [];
  municipio: any = [];
  parroquia: any = [];
  pais: any = [];

  errorMessage: string = '';

  private srvLogin = inject(InicioService);
  private servicios = inject(UsuarioService);
  private fb = inject(FormBuilder)
  private url = appsettings.apiUrl;

  formulario: FormGroup;
  constructor( ){
    this.formulario = this.fb.group({
      //---- datos_institucional ----
      estado: ['', Validators.required],
      municipio: ['', Validators.required],
      parroquia: ['', Validators.required],
      pais: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.srvLogin.user$.subscribe(user => { this.user = user; });
  }

  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.servicios.listarDatosCombo().subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        console.log('aaaa:  ',rs)
        this.estado = rs.data[0].estado;
        this.pais = rs.data[0].pais;
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  municipio_fun(id: any){
    this.mdl.cargando();
    this.servicios.municipio(id.value).subscribe({
      next:(dt)=>{
        this.municipio = dt.data;
        this.mdl.cerrar();
      }
    })
  }

  parroquia_fun(id: any){
    this.mdl.cargando();
    this.servicios.parroquia(id.value).subscribe({
      next:(dt)=>{
        this.parroquia = dt.data;
        this.mdl.cerrar();
      }
    })
  }

    async descargar_formato(){
     if(!this.formulario.valid){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = "Debe completar los campos requeridos del formulario (*)";
      this.mdl.alerta();
    }
    else{
      Object.assign(this.formulario.value, {'id_institucional': this.user.id_institucional});
      console.log('usuario: ',this.formulario.value)
      let ruta;
      this.mdl.cargando();
      this.servicios.descargarFormatoParticipante(this.formulario.value).subscribe({
        next: (rs) => {
          window.location.href = `${this.url}${rs.data}.xls`;

          console.log('aaaaaa: ',rs.data)

          this.mdl.cerrar();
          ruta = rs.data;
        },
        error: (error) => {
          this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        }
      });
      //await this.borrar(ruta);
    }
  }


}
